import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';
import { ReactNode } from 'react';
import KubitTooltip from '../KubitTooltip';
import { isEqual } from 'lodash';
interface IProps<T> {
  options: Array<{
    value: T;
    label: string | ReactNode;
    hint?: string;
  }>;
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: ${theme.colors.level1};
  border: 1px solid ${theme.colors.border};
`;

const activeOptionStyles = css`
  background: ${theme.colors.blue500};
  color: ${theme.colors.mainBlue};
  border: 1px solid ${theme.colors.mainBlue};
`;

const Option = styled.button<{ $isActive: boolean }>`
  // avoid text selection on button
  font-family: inherit;
  user-select: none;
  flex: 1;
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  color: ${theme.colors.secondary400};
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;

  :not(:last-child) {
    border-right: 1px solid ${theme.colors.border};
  }

  :hover {
    cursor: pointer;
    ${activeOptionStyles}
  }

  // add selector to override the :not(:last-child) styles
  &[type='button'] {
    ${({ $isActive }) =>
      $isActive &&
      css`
        ${activeOptionStyles}
      `}
  }
`;

const SegmentSelect = <T,>({
  options,
  value,
  onChange,
  className,
}: IProps<T>) => {
  return (
    <Container className={className}>
      {options.map((option) => (
        <KubitTooltip
          key={String(option.value)}
          disabled={!option.hint}
          content={option.hint}
        >
          <Option
            $isActive={isEqual(option.value, value)}
            onClick={() => onChange(option.value)}
            type="button"
          >
            {option.label}
          </Option>
        </KubitTooltip>
      ))}
    </Container>
  );
};

export default SegmentSelect;
